import { Route } from '@angular/router';
import { PublicComponent } from './public.component';

export const publicRoutes: Route[] = [
  {
    path: 'public',
    component: PublicComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./login/login.component').then(
            (m) => m.LoginComponent,
          ),
      },
      {
        path: '**',
        redirectTo: 'login',
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
];
